<!-- Le Header est global et s'affiche sur toutes les pages -->
<app-header ngSkipHydration></app-header>

<!-- Le contenu change dynamiquement en fonction de la route active (ex: HomeComponent) -->
<main class="main-content">
  <router-outlet></router-outlet>
  <app-cookie-banner></app-cookie-banner>
</main>

<!-- Le Footer est global et s'affiche sur toutes les pages -->
<app-footer></app-footer>